var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 11.5156L13.4465 9.10251L24.7398 2.5L36.0664 9.10251L31.9144 11.5156L24.7398 7.35971L17.5984 11.5156ZM39.0226 15.6715V20.5312L43.1746 18.1182V13.2584L39.0226 10.8118L34.8706 13.2249L39.0226 15.6715ZM20.5878 13.2584L24.7398 15.6715L28.8918 13.2584L24.7398 10.8118L20.5878 13.2584ZM36.0664 17.4142L31.9144 15.0012L24.7398 19.1571L17.5984 15.0012L13.4465 17.4142V22.274L20.5878 26.4298V34.7416L24.7398 37.1547L28.8918 34.7416V26.4298L36.0664 22.274V17.4142ZM39.0226 32.3286L31.8813 36.4845V41.3442L43.2078 34.7416V21.5702L39.0226 24.0168V32.3286ZM31.8813 33.0324L36.0331 30.6193V25.726L31.8813 28.1391V33.0324ZM20.5878 38.2273V43.0869L24.7398 45.5001L28.8918 43.0869V38.2273L24.7398 40.6404L20.5878 38.2273ZM6.27185 18.1182L10.4238 20.5312V15.6715L14.5758 13.2584L10.457 10.8118L6.30507 13.2249V18.1182H6.27185ZM10.457 24.0168L6.30507 21.6037V34.7752L17.6316 41.3776V36.518L10.457 32.3286V24.0168ZM17.5984 28.1727L13.4465 25.7596V30.6193L17.5984 33.0324V28.1727Z",
    fill: "#F1BA0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.624cec24b39f17ba1ed97c4dfbb096fb.svg";
export { ForwardRef as ReactComponent };